export { PLUGIN_KEY, PLUGIN_PRIORITY, ManualColumnFreeze } from "./manualColumnFreeze.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/manualColumnFreeze/index.mjs
// module id = 1452
// module chunks = 1